// Central photo registry — easy-to-swap URLs (Pexels + Unsplash, all verified 200).
// Replace URLs below when Manou provides her own photos.

const px = (id, w = 1200) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
const un = (id, w = 1200) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=85`;

// Logo — Manou's brand identity (user-provided asset).
export const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_manou-creations/artifacts/ua9t5v1p_ChatGPT%20Image%2017%20juil.%202026%2C%2023_11_45.png";

export const photos = {
  // Hero — close-up of a child face-painted (delicate, joyful, artistic)
  hero: un("1514793302631-293f95fcd7e7", 1800),

  // Beside the "About Manou" story — paint palette (materials, no person)
  portrait: "/gallery/palette-1.png",

  // Two service cards
  serviceEnfants: un("1514793302631-293f95fcd7e7", 1200),
  serviceAdultes: "/gallery/carnaval.png",

  gallery: {
    enfants: [
      { src: "/gallery/butterfly.png", alt: "Maquillage papillon aquarelle — détail autour de l'œil." },
      { src: "/gallery/spiderman.png", alt: "Maquillage Spiderman — motif toile autour de l'œil." },
      { src: "/gallery/hello-kitty.png", alt: "Maquillage Hello Kitty sur joue d'enfant." },
      { src: "/gallery/palette-1.png", alt: "Palette de maquillage enfant, tourbillon de couleurs." },
      { src: "/gallery/glitter.png", alt: "Paillettes et étoiles pastel qui s'envolent." },
      { src: "/gallery/materials.png", alt: "Matériel de maquillage artistique en pose éclatée." },
      { src: "/gallery/palette-2.png", alt: "Palette et pinceaux de maquilleuse." },
      { src: "/gallery/kermesse.png", alt: "Stand de kermesse aquarelle, ambiance festive." },
    ],
    adultes: [
      { src: "/gallery/carnaval.png", alt: "Maquillage de carnaval, masque doré et coloré." },
      { src: "/gallery/glitter.png", alt: "Paillettes iridescentes pour la scène." },
      { src: "/gallery/palette-1.png", alt: "Palette éclatante — création en cours." },
      { src: "/gallery/butterfly.png", alt: "Motif papillon détaillé et pailleté." },
      { src: "/gallery/materials.png", alt: "Matériel professionnel de maquillage." },
      { src: "/gallery/palette-2.png", alt: "Pinceaux et couleurs de scène." },
    ],
    evenements: [
      { src: "/gallery/kermesse.png", alt: "Ambiance kermesse et fête foraine." },
      { src: "/gallery/palette-1.png", alt: "Palette et créations sur stand." },
      { src: "/gallery/carnaval.png", alt: "Motif carnaval, féerie de couleurs." },
      { src: "/gallery/glitter.png", alt: "Paillettes qui virevoltent, magie de l'événement." },
      { src: "/gallery/materials.png", alt: "Matériel prêt pour l'événement." },
      { src: "/gallery/butterfly.png", alt: "Maquillage papillon prisé lors des fêtes." },
      { src: "/gallery/palette-2.png", alt: "L'atelier au cœur de l'événement." },
    ],
  },
};
